import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";

export default function MobileListPagination({
  count = 0,
  page = 0,
  rowsPerPage = 8,
  onPageChange,
  label = "registros",
  sx,
}) {
  const safeCount = Math.max(0, Number(count || 0));
  const safeRows = Math.max(1, Number(rowsPerPage || 1));
  const totalPages = Math.max(1, Math.ceil(safeCount / safeRows));
  const currentPage = Math.min(Math.max(0, Number(page || 0)), totalPages - 1);
  const from = safeCount ? currentPage * safeRows + 1 : 0;
  const to = safeCount ? Math.min(safeCount, (currentPage + 1) * safeRows) : 0;

  return (
    <Box sx={{ px: 1, py: 1, ...sx }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
        <Button
          size="small"
          variant="outlined"
          startIcon={<ChevronLeftRoundedIcon />}
          disabled={currentPage <= 0}
          onClick={(event) => onPageChange?.(event, currentPage - 1)}
          sx={{ minHeight: 44, minWidth: 0, flex: "1 1 0", px: .75, borderRadius: 2.2, textTransform: "none", fontWeight: 900 }}
        >
          Anterior
        </Button>

        <Box sx={{ minWidth: 76, flex: "0 0 auto", textAlign: "center" }}>
          <Typography sx={{ fontSize: ".78rem", fontWeight: 950, lineHeight: 1.15 }}>
            {from}-{to} de {safeCount}
          </Typography>
          <Typography variant="caption" sx={{ color: "text.secondary", fontSize: ".67rem", fontWeight: 750 }}>
            {label} · pág. {currentPage + 1}/{totalPages}
          </Typography>
        </Box>

        <Button
          size="small"
          variant="outlined"
          endIcon={<ChevronRightRoundedIcon />}
          disabled={currentPage >= totalPages - 1 || safeCount === 0}
          onClick={(event) => onPageChange?.(event, currentPage + 1)}
          sx={{ minHeight: 44, minWidth: 0, flex: "1 1 0", px: .75, borderRadius: 2.2, textTransform: "none", fontWeight: 900 }}
        >
          Siguiente
        </Button>
      </Stack>
    </Box>
  );
}
